import { render, staticRenderFns } from "./footerMap.vue?vue&type=template&id=53df1b52&scoped=true&"
import script from "./footerMap.vue?vue&type=script&lang=js&"
export * from "./footerMap.vue?vue&type=script&lang=js&"
import style0 from "./footerMap.vue?vue&type=style&index=0&id=53df1b52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df1b52",
  null
  
)

export default component.exports